import { history } from "./history";
import get from "lodash/get";
import unset from "lodash/unset";
import commonConfig from "../config/common";
import configureStore from "../state/store";

const setupStore = () => {
  const {
    globalKeys: { storeKey }
  } = commonConfig;
  const initialState = get(window, storeKey);
  unset(window, storeKey);
  const store = configureStore(history, initialState);

  return store;
};

export default setupStore;
